import React from 'react'
import locationIcon from '../../assets/icons/location-icon.svg'
import crossIcon from "../../assets/icons/cross-icon.svg"
import Address from './Address'
import '../../styles/Modal.css'
import { getAssetUrl } from '../../utils/lib'


const StoreModal = ({ isOpen, onClose, store }) => {

  if(!isOpen) return null

  return (
    <div className="modal-overlay">
        <div className="store-modal-content">
            <div className='cross-container' onClick={onClose}>   
                <img className="crusor-icon" src={getAssetUrl(crossIcon)}  alt="Cross Icon" />
            </div>
            <div className="top-section">
                <div className="heading-section">
                    <h3>{store.Name} </h3>
                    <div className="distance-container">
                        <img src={getAssetUrl(locationIcon)} className="location-icon" alt="Location Icon" />
                        <div className="distance">({store.distance.toFixed(2)} km away)</div>
                    </div>
                </div>
            </div>
          <p className="address"><Address address={store.PIAB__Street__c}/>
                              {store.PIAB__City__c}  {store.PIAB__State__c} {store.PIAB__Postal_Code__c}</p>
            <p className="phone">Phone: {store.PIAB__Phone__c || 'Not available'}</p>
      </div>
    </div>
  )
}

export default StoreModal